// Copyright (c) 2019 Deere & Company

import {updateClaimModalMode, updateCreateClaimModalVisibility} from './create-claim-modal-visibility';
import actions from '../../action-list';
import {createWearPartsClaim} from './validate-claim';
import {getUpdatedWearPartsClaim} from '../services/update-wear-parts-claim';
import {isActionResetFormValidation} from '../../shared/services/claim-shared-helper';

export const updateSelectedAction = selectedAction =>

    (dispatch, getState) => {

        const updatedClaim = getUpdatedWearPartsClaim(getState().claims.wearParts.claim, selectedAction);

        const updateModalVisibility = () => {

            updateClaimModalMode('CREATE')(dispatch);
            updateCreateClaimModalVisibility(true)(dispatch);

        };

        const updateIsEditable = () => {

            dispatch({
                isEditable: true,
                type: actions.UPDATE_CLAIM_WEAR_PARTS_IS_EDITABLE
            });

            dispatch({
                type: actions.REVISE_CLAIM_WEAR_PARTS
            });

        };

        if (isActionResetFormValidation(selectedAction.id)) {

            dispatch({
                type: actions.RESET_CLAIM_WEAR_PARTS_FORM_VALIDATION
            });

        }

        const selectedActionIdTypes = {
            CRT: updateModalVisibility,
            REVISE: updateIsEditable
        };

        const updateType = selectedActionIdTypes[selectedAction.id];

        return updateType ? updateType() : createWearPartsClaim(updatedClaim)(dispatch, getState);

    };



// WEBPACK FOOTER //
// ./src/claim/wear-parts/action-creators/update-selected-action.js